"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SFSnackbarAutoHide = exports.SFSnackbar = void 0;
var React = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var FadeTransition_1 = __importDefault(require("../../animations/FadeTransition/FadeTransition"));
var useTimeout_1 = require("../../utils/useTimeout");
require("./SFSnackbar.css");
var moduleName = 'simplifeye-message';
var iconMap = {
    info: 'info',
    success: 'check_circle',
    warning: 'warning',
};
var SFSnackbar = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'info' : _b, children = _a.children, _c = _a.isShown, isShown = _c === void 0 ? true : _c, _d = _a.sticky, sticky = _d === void 0 ? false : _d;
    return (React.createElement("div", { className: moduleName + " " + moduleName + "--" + variant + " " + moduleName + "--" + (isShown ? 'shown' : 'hidden') + " " + (sticky ? moduleName + "--sticky" : '') },
        Boolean(iconMap[variant]) && React.createElement(core_1.Icon, null, iconMap[variant]),
        React.createElement("span", null, children)));
};
exports.SFSnackbar = SFSnackbar;
var SFSnackbarAutoHide = function (_a) {
    var _b = _a.timeoutDelay, timeoutDelay = _b === void 0 ? 5000 : _b, props = __rest(_a, ["timeoutDelay"]);
    var _c = React.useState(false), isRemoved = _c[0], setIsRemoved = _c[1];
    useTimeout_1.useTimeout(function () { return setIsRemoved(true); }, timeoutDelay);
    return (React.createElement(FadeTransition_1.default, { in: !isRemoved },
        React.createElement(SFSnackbar, __assign({}, props))));
};
exports.SFSnackbarAutoHide = SFSnackbarAutoHide;
exports.default = SFSnackbar;
